import * as yup from 'yup';

export const CertificationSchema = yup.object({
    title: yup.string().required('Errors.error_required').max(85, 'Errors.error_max_85'),
    date: yup.string().required('Errors.error_required'),
    source: yup.string().max(80, 'Errors.error_max_80'),
});
